import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@mono/ui-components';
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraIconButton } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { MoreHorizontal } from 'lucide-react';
import { useState } from 'react';
/**
 * GRW-39: one per-row actions menu replacing standalone Edit/Remove buttons.
 * Renders nothing when `readOnly` or when no action is given.
 */ export function RowActionsMenu({ rowName, readOnly, onEdit, remove, triggerTestId }) {
    const [confirming, setConfirming] = useState(false);
    if (readOnly || !onEdit && !remove) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(DropdownMenu, {
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                        asChild: true,
                        children: /*#__PURE__*/ _jsx(SpecraIconButton, {
                            label: `Actions for ${rowName}`,
                            variant: "ghost",
                            size: "sm",
                            "data-testid": triggerTestId ?? Testids.capture.rowActionsTrigger,
                            children: /*#__PURE__*/ _jsx(MoreHorizontal, {
                                className: "h-4 w-4",
                                "aria-hidden": true
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                        align: "end",
                        children: [
                            onEdit && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                disabled: onEdit.disabled,
                                onSelect: onEdit.onSelect,
                                "data-testid": onEdit.testId,
                                children: onEdit.label ?? 'Edit'
                            }),
                            remove && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                disabled: remove.disabled,
                                onSelect: ()=>remove.immediate ? remove.onConfirm() : setConfirming(true),
                                "data-testid": remove.testId,
                                children: remove.label ?? 'Remove'
                            })
                        ]
                    })
                ]
            }),
            remove && !remove.immediate && /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
                open: confirming,
                onOpenChange: setConfirming,
                title: remove.title,
                description: remove.description,
                size: "sm",
                testId: Testids.capture.removeConfirmDialog,
                footerProps: {
                    confirmLabel: 'Remove',
                    onConfirm: ()=>{
                        setConfirming(false);
                        remove.onConfirm();
                    },
                    confirmProps: {
                        'data-testid': Testids.capture.removeConfirm
                    }
                },
                children: /*#__PURE__*/ _jsx("span", {})
            })
        ]
    });
}
